export const SUPPORTED_LANGUAGES = ['en', 'pl'] as const;
export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];

export const DEFAULT_LANGUAGE: SupportedLanguage = 'en';
export const LANGUAGE_STORAGE_KEY = 'cms.language';

const LANGUAGE_PREFIX_REGEX = new RegExp(
  `^/(${SUPPORTED_LANGUAGES.join('|')})(?=/|$)`,
);

export const isSupportedLanguage = (
  lng?: string | null,
): lng is SupportedLanguage =>
  !!lng && (SUPPORTED_LANGUAGES as readonly string[]).includes(lng);

export const detectLanguage = (): SupportedLanguage => {
  try {
    const stored = localStorage.getItem(LANGUAGE_STORAGE_KEY);
    if (isSupportedLanguage(stored)) return stored;
  } catch {
    // ignore
  }

  const fromBrowser = (navigator.languages ?? [navigator.language])
    .map((lng) => lng?.split('-')[0])
    .find(isSupportedLanguage);

  return fromBrowser ?? DEFAULT_LANGUAGE;
};

export const persistLanguage = (lng: string) => {
  const normalized = lng.split('-')[0];
  if (!isSupportedLanguage(normalized)) return;
  try {
    localStorage.setItem(LANGUAGE_STORAGE_KEY, normalized);
  } catch {
    // ignore
  }
};

export const stripLanguagePrefix = (pathname: string) =>
  pathname.replace(LANGUAGE_PREFIX_REGEX, '') || '/';

export const buildLanguagePath = (lng: string, pathname: string, search = '') =>
  `/${lng}${stripLanguagePrefix(pathname)}${search}`;
